import { createAction } from "@reduxjs/toolkit"

export const setCredit = createAction('credit/setCredit')
export const setCreditValue = createAction('credit/setCreditValue')
export const clearCredit = createAction('credit/clearCredit')
